import React, { useContext } from 'react';
import logo from '../../assets/newmonaassets/logo_mona.png';
import './Footer.scss';
import { FaFacebookF, FaInstagram, FaTwitter} from "react-icons/fa";
import { Link } from 'react-router-dom';
import call from '../../assets/footer/calling.png';
import time from '../../assets/footer/time.png';
import location from '../../assets/footer/location.png';
import { LanguageContext } from '../../context/LanguageContext';

const Footer = () => {
    const { t } = useContext(LanguageContext);

    const footerMenu = [
        {
            'name' : t('footer.links.aboutUs'),
            'link' : '/'
        },
        {
            'name' : t('footer.links.services'),
            'link' : '/'
        },
        {
            'name' : t('footer.links.dentist'),
            'link' : '/'
        },
        {
            'name' : t('footer.links.faqs'),
            'link' : '/'
        }
    ];

    // Formatlanmış telefon numarası
    const formattedPhoneNumber = t('footer.contact.phone.value');
    // Tel bağlantısı için formatlanmış numara (boşluklar olmadan)
    const callablePhoneNumber = formattedPhoneNumber.replace(/\s/g, '');

    const footerContacts = [
        {
            'title': t('footer.contact.phone.title'),
            'info': formattedPhoneNumber,
            'icon': call,
            'isPhone': true
        },
        {
            'title': t('footer.contact.hours.title'),
            'info': t('footer.contact.hours.value'),
            'icon': time,
            'isPhone': false
        },
        {
            'title': t('footer.contact.address.title'),
            'info': t('footer.contact.address.value'),
            'icon': location,
            'isPhone': false
        }
    ]

    return (
        <footer className='pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <div className="footer-logo">
                            <img src={logo} alt="Mona Klinik" />
                        </div>
                        <p>{t('footer.description')}</p>

                        <div className="social-logo">
                            <p>{t('footer.followUs')}</p>
                            <ul>
                                <li><a href="/"><FaFacebookF/></a></li>
                                <li><a href="/"><FaTwitter/></a></li>
                                <li><a href={t('footer.socialMedia.instagram')}><FaInstagram/></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                        <div className="footer-link">
                            <p>{t('footer.quickLinks')}</p>
                            <ul>
                                {
                                    footerMenu.map((singleMenu, index) => <li key={index}><Link to="/">{singleMenu.name}</Link></li>)
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <p>{t('footer.contact.title')}</p>

                            {
                                footerContacts.map((footerContact, index) => {
                                    return (
                                        <div className="contact-list" key={index}>
                                            {footerContact.isPhone ? (
                                                <>
                                                    <a href={`tel:${callablePhoneNumber}`} className="contact-icon clickable-icon">
                                                        <img src={footerContact.icon} alt="call" />
                                                    </a>
                                                    <a href={`tel:${callablePhoneNumber}`} className="contact-text contact-phone">
                                                        <p>{footerContact.title}</p>
                                                        <h5>{footerContact.info}</h5>
                                                    </a>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="contact-icon">
                                                        <img src={footerContact.icon} alt={footerContact.title} />
                                                    </div>
                                                    <div className="contact-text">
                                                        <p>{footerContact.title}</p>
                                                        <h5>{footerContact.info}</h5>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>&copy; Monaklinik. All Right Reserved</p>
                    </div>  
                    <div className='copy-links'>
                        <ul>
                            <li><Link to='/'>Terms of Use</Link></li>
                            <li><Link to='/'>Privacy Policy</Link></li>
                        </ul>
                    </div>                          
                </div>
            </div>
        </footer>
    );
};

export default Footer;